import { render, staticRenderFns } from "./AddEditAcademicStatus.vue?vue&type=template&id=53468cc9"
import script from "./AddEditAcademicStatus.vue?vue&type=script&lang=js"
export * from "./AddEditAcademicStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports